import { Link } from "react-router-dom";
import { CONTACT, NAV, LOGO_DARK } from "@/data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-ink text-greige mt-px">
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <img src={LOGO_DARK} alt="2e Lab" className="h-20 w-auto mb-6" data-testid="footer-logo" />
        <p className="font-mono2 text-xs uppercase tracking-widest text-greige/50 mb-4">2E LAB. Designer di Idee</p>
        <p className="font-heading text-3xl md:text-4xl leading-tight">con metodo,<br />non con l'AI al posto del cervello.</p>
      </div>
      <div className="md:col-span-3 md:col-start-7">
        <p className="font-mono2 text-xs uppercase tracking-widest text-greige/50 mb-5">Mappa</p>
        <ul className="space-y-3 font-body text-sm">
          {NAV.map((n) => <li key={n.to}><Link to={n.to} className="link-underline hover-bold-noshift text-greige/80 hover:text-greige">{n.label}</Link></li>)}
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono2 text-xs uppercase tracking-widest text-greige/50 mb-5">Contatti</p>
        <ul className="space-y-3 font-body text-sm text-greige/80">
          <li><a href={`mailto:${CONTACT.email}`} className="link-underline" data-testid="footer-email">{CONTACT.email}</a></li>
          <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="link-underline">{CONTACT.phone}</a></li>
          <li><a href={CONTACT.instagramUrl} target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-instagram">{CONTACT.instagram}</a></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-greige/15">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 font-mono2 text-[11px] uppercase tracking-widest text-greige/40">
        <span>© {new Date().getFullYear()} 2e Lab. twoelab.com</span>
        <div className="flex flex-wrap gap-5">
          <Link to="/privacy" className="hover:text-greige" data-testid="footer-privacy">Privacy Policy</Link>
          <Link to="/cookie-policy" className="hover:text-greige" data-testid="footer-cookie">Cookie Policy</Link>
          <Link to="/termini" className="hover:text-greige" data-testid="footer-terms">Termini</Link>
          <button onClick={() => window._iub?.cs?.api?.openPreferences?.()} className="uppercase tracking-widest hover:text-greige" data-testid="footer-cookie-prefs">Preferenze cookie</button>
        </div>
      </div>
    </div>
  </footer>
);
